enum Services {
  GenerateReturnOrder = 1,
  GenerateBenchTemplate = 2,
  ShowReturnLabel = 3,
  LabServices = 4,
  ShippingMethodRequired = 5
}

enum Organizations {
  WellsFargo = 1,
  ExpRealty = 2,
  Ameresco = 5,
  Demo = 6
}

enum SecurityRole {
  Administrator = 1,
  GeneralUser = 2,
  Engineer = 3,
  EPCEngineer = 4,
  GeneralEngineerUser = 5,
  ClientAdministrator = 6,
  GeneralUserBoxesAndLabels = 7
}

enum BenchTemplateStatus {
  Pending = 1,
  ReadyBenched = 2,
  Benched = 3,
  Finalized = 4,
  AwaitingAssignment = 5,
  Cancelled = 7
}

enum RedeploymentOrderStatus {
  Open = 1,
  Cancelled = 2,
  Shipped = 3,
  PendingCancellation = 4
}

export { Services, Organizations, SecurityRole, BenchTemplateStatus, RedeploymentOrderStatus }

